import {Component} from "@angular/core";
import {GenericHeaderComponent} from "../../../generic-header";

declare var jquery:any;
declare var $ :any;

/**
 * Created by Benoit Valkenberg on 03-12-17.
 */
@Component({
    selector: "home-header",
    styleUrls: ['./header.scss'],
    templateUrl: "./header.html"
})
export class GarageMainHeaderComponent extends GenericHeaderComponent{

    public discoverClicked(){
        $('html, body').stop().animate({scrollTop:  $("#presentation").offset().top - 100}, 1000, 'swing');
    }
}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/garage/main/header/header.ts